const getters = {
  getPaymentToInsurerRequest: (state) => state.paymentToInsurerRequest,
  getPaymentToInsurerRequestList: (state) => state.paymentToInsurerRequestList,
  getPaymentToInsurerRequestListMeta: (state) =>
    state.paymentToInsurerRequestMeta,

  getInsurerBranchList: (state) => state.insurerBranchList,
  getSelectedInsurer: (state) => state.selectedInsurer,
  getFetchParameter: (state) => state.fetchParameter,
};

export default getters;
